"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApiErrorConstructor = exports.ZeroResultsError = exports.UnknownError = exports.InvalidRequestError = exports.RequestDeniedError = exports.QueryLimitExceededError = exports.DailyLimitExceededError = exports.FailureStatus = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Google.Geocode.Error';
exports.FailureStatus = effect_1.Schema.Literal('OVER_DAILY_LIMIT', 'OVER_QUERY_LIMIT', 'REQUEST_DENIED', 'INVALID_REQUEST', 'UNKNOWN_ERROR', 'ZERO_RESULTS').annotations({
    identifier: `${NAMESPACE}.FailureStatus`,
    documentation: 'https://developers.google.com/maps/documentation/geocoding/guides-v3/requests-geocoding#StatusCodes',
});
class DailyLimitExceededError extends effect_1.Data.TaggedError(`${NAMESPACE}.DailyLimitExceededError`) {
    get message() {
        return 'The API daily quota has been exceeded.';
    }
}
exports.DailyLimitExceededError = DailyLimitExceededError;
class QueryLimitExceededError extends effect_1.Data.TaggedError(`${NAMESPACE}.QueryLimitExceededError`) {
    get message() {
        return 'The API quota has been exceeded.';
    }
}
exports.QueryLimitExceededError = QueryLimitExceededError;
class RequestDeniedError extends effect_1.Data.TaggedError(`${NAMESPACE}.RequestDeniedError`) {
    get message() {
        return 'The request has been denied, possibly due to a missing or invalid API key.';
    }
}
exports.RequestDeniedError = RequestDeniedError;
class InvalidRequestError extends effect_1.Data.TaggedError(`${NAMESPACE}.InvalidRequestError`) {
    get message() {
        return 'The request is invalid, possibly due to a missing or malformed query parameter.';
    }
}
exports.InvalidRequestError = InvalidRequestError;
class UnknownError extends effect_1.Data.TaggedError(`${NAMESPACE}.UnknownError`) {
    get message() {
        return 'The request could not be processed due to an internal server error.';
    }
}
exports.UnknownError = UnknownError;
class ZeroResultsError extends effect_1.Data.TaggedError(`${NAMESPACE}.ZeroResultsError`) {
    get message() {
        return 'No results were returned by the API. The provided `latlng` is probably in a remote location.';
    }
}
exports.ZeroResultsError = ZeroResultsError;
/**
 * See {@link FailureStatus} and {@link ApiErrorConstructor}
 */
const API_ERROR_STATUS_MAP = {
    OVER_DAILY_LIMIT: DailyLimitExceededError,
    OVER_QUERY_LIMIT: QueryLimitExceededError,
    REQUEST_DENIED: RequestDeniedError,
    INVALID_REQUEST: InvalidRequestError,
    UNKNOWN_ERROR: UnknownError,
    ZERO_RESULTS: ZeroResultsError,
};
/**
 * Utility function to derive the associated {@link ApiErrorConstructor}
 * from the provided {@link FailureStatus}
 */
const getApiErrorConstructor = (status) => API_ERROR_STATUS_MAP[status];
exports.getApiErrorConstructor = getApiErrorConstructor;
//# sourceMappingURL=error.js.map